import { render } from "./AskDoubtassTeacher.vue?vue&type=template&id=6682ceae&scoped=true"
import script from "./AskDoubtassTeacher.vue?vue&type=script&lang=js"
export * from "./AskDoubtassTeacher.vue?vue&type=script&lang=js"

import "./AskDoubtassTeacher.vue?vue&type=style&index=0&id=6682ceae&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6682ceae"]])

export default __exports__